import { useEffect } from 'react';

function Donate() {
  useEffect(() => {
    // Load Zeffy embed script
    const script = document.createElement('script');
    script.src = 'https://www.zeffy.com/embed/v2/zeffy-embed.js';
    script.async = true;
    script.onerror = () => {
      // Fallback: show iframe if script fails to load
      document.querySelectorAll('[data-zeffy-embed-fallback]').forEach((el) => {
        el.style.display = 'block';
        el.querySelectorAll('iframe[data-zeffy-embed-src]').forEach((f) => {
          f.src = f.getAttribute('data-zeffy-embed-src');
        });
      });
    };
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section className="donate-section" id="donate">
      <div className="container">
        <div className="donate-content">
          <div className="donate-text">
            <h2>Your Impact Is Immediate and Real</h2>
            <p>
              <strong>$50</strong> equips a Dallas student with a full year of school supplies.
              <br /><strong>$100</strong> brings hands-on STEM kits to a rural Nepal classroom.
              <br /><strong>$500</strong> trains a teacher in hands-on science education.
              <br /><strong>$1,000</strong> establishes the first science lab in a Himalayan village.
            </p>
            <p style={{ marginTop: '1rem' }}>
              Every dollar goes directly to students. Zero overhead from leadership—we're
              100% volunteer-driven. Your donation today becomes a microscope, a backpack,
              a calculator, or a science fair in someone's hands by next month.
            </p>
            <div className="donate-stats">
              <div className="donate-stat">
                <i className="fas fa-hand-holding-heart"></i>
                <div>
                  <strong>100%</strong>
                  <span>To Students</span>
                </div>
              </div>
              <div className="donate-stat">
                <i className="fas fa-users-cog"></i>
                <div>
                  <strong>0%</strong>
                  <span>Executive Salaries</span>
                </div>
              </div>
              <div className="donate-stat">
                <i className="fas fa-shield-alt"></i>
                <div>
                  <strong>501(c)(3)</strong>
                  <span>Tax-Deductible</span>
                </div>
              </div>
            </div>
          </div>
          <div className="donate-form-wrapper">
            <div>
              <div data-zeffy-embed data-form-url="/embed/donation-form/empowering-underserved-students"></div>
              <div data-zeffy-embed-fallback style={{ display: 'none' }}>
                <div style={{ position: 'relative', overflow: 'hidden', height: '450px', width: '100%' }}>
                  <iframe
                    title='Donation form powered by Zeffy'
                    style={{ position: 'absolute', border: 0, top: 0, left: 0, bottom: 0, right: 0, width: '100%', height: '100%' }}
                    data-zeffy-embed-src='https://www.zeffy.com/embed/donation-form/empowering-underserved-students'
                    allowpaymentrequest="true"
                    allowTransparency="true"
                  />
                </div>
              </div>
            </div>
            {/* <div className="donate-form">
              <h3>Choose Your Impact</h3>
              <div className="donation-amounts">
                {amounts.map((a) => (
                  <button
                    key={a.value}
                    className={`amount-btn ${selectedAmount === a.value ? 'active' : ''}`}
                    onClick={() => setSelectedAmount(a.value)}
                  >
                    {a.label}
                  </button>
                ))}
              </div>
              <div className="donation-frequency">
                <label>
                  <input
                    type="radio"
                    name="frequency"
                    value="one-time"
                    checked={frequency === 'one-time'}
                    onChange={(e) => setFrequency(e.target.value)}
                  />
                  <span> One-Time</span>
                </label>
                <label>
                  <input
                    type="radio"
                    name="frequency"
                    value="monthly"
                    checked={frequency === 'monthly'}
                    onChange={(e) => setFrequency(e.target.value)}
                  />
                  <span> Monthly (STEM Sustainer)</span>
                </label>
              </div>
              <div className="donate-cta">
                <a
                  href="https://www.zeffy.com/en-US/donation-form/empowering-underserved-students"
                  className="btn btn-large btn-primary"
                >
                  <i className="fas fa-envelope"></i> Contact Us to Donate
                </a>
                <p className="donate-note">
                  Donation processing will be available once our 501(c)(3) is approved.
                  Email us to pledge your support now!
                </p>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Donate;
